import { useState, useEffect, createRef } from 'react'
import { useRouter } from 'next/router'
import styles from './TextSearchBar.module.scss'

export default function TextSearchBar({ callback, children, origValue }) {
  const router = useRouter()
  const [search, changeVal] = useState('')
  const [isFocused, changeFocus] = useState(false)
  const inputRef = createRef()

  useEffect(() => {
    if (isFocused) inputRef.current.focus()
  }, [isFocused])

  useEffect(() => changeVal(origValue || ''), [origValue])

  const searchUpdate = async ({ target }) => {
    const { value } = target
    changeVal(value)
    if (callback) return callback({ search: value })
    if (!inputRef.current.isFocused) inputRef.current.focus()
  }
  const focusSearch = (e, isFocus = false) => {
    const visible = !!search || isFocus
    changeFocus(visible)
  }
  const handleSearch = async () => {
    router.push({ pathname: '/haku', query: { search, page: 1 } })
  }

  return (
    <>
      <div
        className={`${styles.searchField}`}
        typing={isFocused ? 'true' : undefined}
        onClick={(e) => focusSearch(e, true)}
      >
        <span className={styles.searchIcon}></span>
        <input
          ref={inputRef}
          type="text"
          value={search}
          className={styles.inputStyle}
          onInput={(e) => searchUpdate(e)}
          onFocus={(e) => focusSearch(e, true)}
          onBlur={(e) => focusSearch(e, false)}
          onKeyDown={({ key }) => key === 'Enter' && handleSearch()}
        />
        {!!search && (
          <span
            className={styles.clearIcon}
            onClick={() => searchUpdate({ target: { value: '' } })}
          ></span>
        )}
      </div>
      {children}
    </>
  )
}
